export const SET_KEYS = 'Keys/set';
export const SET_KEYS_BLACKLISTS = 'Keys/Blacklists/set';
export const SET_KEYS_UPDATED = 'Keys/UpdateStatus/set';
export const SET_KEYS_KEYTYPES = 'Keys/KeyTypes/set';
